export const ADD_HABIT = 'ADD_HABIT';
export const UPDATE_HABIT_STATUS = 'UPDATE_HABIT_STATUS';
